import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'

/*
 * Check if some of the connected wallboxes share the same name(usually the default hardware name).

 * This information is used to conditionally append wallbox id next to the wallbox name in the table to
 * differentiate between two wallboxes sharing the same name.
 */
export const getDuplicateWallboxNamesV1 = (wallboxes: WallboxHardwareModel[]): string[] => {
  const wallboxNameCounts: Record<string, number> = {}

  wallboxes.forEach(wallbox => {
    if (!wallbox.deviceName) {
      return
    }

    wallboxNameCounts[wallbox.deviceName] = (wallboxNameCounts[wallbox.deviceName] || 0) + 1
  })

  const duplicateWallboxNames = Object.keys(wallboxNameCounts).filter(name => wallboxNameCounts[name] > 1)

  return duplicateWallboxNames
}
